import React from 'react';
import DateFormatter from '../../shims/date-formatter.js';
import "./sass/ship-to-home-option.scss";

function ShipToHomeOption({
  fulfillmentDetails,
  selected=true,
  select=()=>{},
  details
}) {
  const enabled = details.enabled;
  const cardClasses =
    `shippingTile card card-container card-background
    ${selected?"card-selected ":"card-unselected "}
    ${enabled?"card-enabled ":"card-unselected "}`;

  const fulfillmentShippingPrice =
      details.hasFreeShipping ?
        "FREE" :
        details.freeShippingThreshhold ?
          "Free with $45 Order":
          "Standard Delivery";

  let priceClass = "";
  if(fulfillmentShippingPrice==="Standard Delivery"){
    priceClass = "standard-delivery";
  }else if(fulfillmentShippingPrice==="Free with $45 Order"){
    priceClass = "free-with-45";
  }

  const dateRange = details.estimatedShippingStartDate !== details.estimatedShippingEndDate;

  let expectedDate = "";
  if(details.arrivalDate){
    expectedDate = details.arrivalDate;
  }else{
    expectedDate =
      details.estimatedShippingStartDate &&
      details.estimatedDeliveryDate ?
        details.estimatedDeliveryDate :
        dateRange ? (
          DateFormatter.convertLongMonthToShort(details.estimatedShippingStartDate) + ' - ' +
          DateFormatter.convertLongMonthToShort(details.estimatedShippingEndDate)
        ) : details.dynamicEtaOptimalDate
  }
  let expectItDate = "";

  if(details.dynamicEtaOptimalDate && !details.isBackordered) {
    expectItDate = details.dynamicEtaOptimalDate;
  }else if((expectedDate && !details.isBackordered) || ( expectedDate && details.isBackordered && dateRange)){
    expectItDate = expectedDate;
  }else{
    expectItDate = "";
  }
  // const expectItDate = (details.dynamicEtaOptimalDate && !details.isBackordered) 
  //                   || ((expectedDate && !details.isBackordered) || ( expectedDate && details.isBackordered && dateRange))
  //                   || ""

  const showDeliveryDate = () =>
    (enabled && (details.rawEstimatedShippingStartDate || expectItDate || details.isBackordered) ?
      (details.isBackordered && details.backorderExpectedShipDate) ? (
        deliveryDate()
      ):(
        details.isBackordered && !details.backorderExpectedShipDate ?
          // deliveryToZip()
          deliveryDate()
          :
          deliveryDate()
      ) : null);

  const deliveryToZip = () => {
    return (<span className="u__legal dai_tileMessage">Delivery to <span className="u__bold">{details.localStore}</span></span>);
  }

  const deliveryDate = () => {

    let backorderExpectedShipDateText = "";
    if(details.isBackordered){
      backorderExpectedShipDateText = "Backordered";
    }else if(dateRange){
      backorderExpectedShipDateText = "Expect it ";
    }else if(expectItDate){
      backorderExpectedShipDateText = "Get it by ";
    }

    return (
      <div className="ship-to-home__delivery-date">
        <div>
          <div data-automation-id="fulfillmentMessageText">
            <span className="dai_tileMessage">
              { backorderExpectedShipDateText }
            </span>
          </div>
        </div>
        {(expectItDate || details.isBackordered) && (
            <div className="u__bold tile-date dai_tileDate">
              {expectItDate}
            </div>

        )}
      </div>
    );
  };

  const shipPrice = () => {
    // const classNameString = details.isBackordered ? "ship-to-home__price--backordered" : "ship-to-home__price--available";
    return (
      <div className="u__center card-messaging-bottom card-messaging-price">
        <div className={'tile-price dai_tilePrice u__bold  u__text--success ' + priceClass}>{fulfillmentShippingPrice}</div>
        </div>);
  };

  const backorderedText = details.isBackordered && !details.backorderExpectedShipDate &&
    <span className="ship-to-home__text ship-to-home__text--backordered dai_tileMessage">
      Backordered
    </span>;

  // const OutOfStockSTHTile =
  //   <div className="u__p-bottom--normal">
  //     <div className="u__legal">
  //       <div data-automation-id="fulfillmentMessageText">
  //         <div className="sTH_Text dai_tilePrice">
  //           Out of Stock
  //         </div>
  //       </div>
  //     </div>
  //   </div>;

  const NotAvailable =
    <div>
      <div>
      {details.sthShippingExclusionApplies && details.sthState && (
        <div className="ship-to-store__message-wrapper">
          <div className="ship-to-store__message shipping-exclusion dai_tileMessage">
            Not available in {getExcludedStateName(details.sthState)}
          </div>
          {<div className="shipping_options_tooltip_link dai_deliveryOptionsLink" id="shipping_options_tooltip_link_container">
                    <a className="u__default-link checkNearbyLink change-delivery-zip">
                      <span id="shipping_options_link" data-tip>Change Zip</span>
                    </a>
                  </div>}
        </div>
      )}
      {!details.sthShippingExclusionApplies &&
        <div data-automation-id="fulfillmentMessageText">
          <div id="unavailable-text" className="ship-to-home__text dai_tileMessage">
              Not available for this item
          </div>
        </div>
      }
      </div>
    </div>;

  const sthTemplate =
    <div className={cardClasses} onClick={()=>{if(enabled){select('STH')}}}>
      <div className={"ship-to-home__wrapper " + (enabled?"":"ship-to-home__wrapper--disabled")}>
        <div className="">
          <div className={"ship-to-home__icon delivery-" + (enabled ? "true" : "false")}/>
          <div className="tile-heading ship-to-home__heading dai_tileHeading">Ship to Home</div>
        </div>
        {showDeliveryDate()}
          {/* <span className="u__bold">{getFulfillmentShippingCost()}</span> */}
        {!enabled && NotAvailable}
        {/* { backordered && (
          <div className="u__p-bottom--normal">
            <div className="u__legal u__p-top--small">
              Backordered
            </div>
          </div>
        )} */}
      </div>
      {enabled && shipPrice()}
    </div>;

  const sthDisabledTemplate = (message) =>
    <div className={cardClasses}>
      <div className={"ship-to-home__disabled"}>
        <div className="">
          <div className={"ship-to-home__icon delivery-false"}/>
          <div className="ship-to-home__disabled__heading dai_tileHeading">
            Ship to Home
          </div>
        </div>
        {message}
      </div>
    </div>;

  return (
    fulfillmentDetails.sthNotAvailable || fulfillmentDetails.isOSSAtOnline ?
      sthDisabledTemplate(NotAvailable) :
      sthTemplate
  );
}


  function getExcludedStateName(stateCode="") {
    if(stateCode==="HI"){
      return "Hawaii";
    }else if(stateCode==="AK"){
      return "Alaska";
    }else{
      return stateCode;
    }
  }

export default ShipToHomeOption;
